import { Grid, Typography } from "@material-ui/core";
import ReportCard from "../components/reportCard";
import ProjectImage from "../assets/img/project.jpg";
import TypeImage from "../assets/img/types.jpg";
import CounterImage from "../assets/img/counter.jpg";
import ConsumptionImage from "../assets/img/consumption.webp";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import useCustomState from "../hooks/State";

const Reports = (props) => {
  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const navigations = [{ name: "گزارشات", path: "/admin/reports" }];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
  }, []);

  const reportTypes = [
    {
      title: "گزارش پروژه ها",
      image: ProjectImage,
      link: "/admin/reports/projects",
    },
    {
      title: "گزارش نوع کنتورها",
      image: TypeImage,
      link: "/admin/reports/counter-types",
    },
    {
      title: "گزارش کنتورها",
      image: CounterImage,
      link: "/admin/reports/counters",
    },
    {
      title: "گزارش مصرف",
      image: ConsumptionImage,
      link: "/admin/reports/consumptions",
    },
  ];

  return (
    <Grid
      container
      style={{
        paddingTop: "48px",
        paddingBottom: "16px",
        paddingRight: "24px",
        paddingLeft: "24px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ paddingBottom: "24px" }}
      >
        <Typography style={{ fontWeight: "bold" }}>انواع گزارش</Typography>
      </Grid>
      {reportTypes.map((type, idx) => {
        return (
          <ReportCard
            title={type.title}
            image={type.image}
            link={type.link}
            key={idx}
          />
        );
      })}
    </Grid>
  );
};

export default Reports;
